<template>
  <h3 style="text-align:center;padding-top:30%;">404页面不存在</h3>
</template>

<script>
export default {}
</script>

<style></style>